module.exports = __webpack_public_path__ + "img/login_blk.4320051e.png";